<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.networkTitle"/>

  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isRouterAlive: true,
    }

  },
  mounted() {
    console.log('app init')
    console.log(
       `%c 分支-organizational %c 开发者云玺 %c`,
       'background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
       'background:#aa00ff ;padding: 1px; border-radius: 0 3px 3px 0;  color: #fff; font-weight: bold;',
       'background:transparent'
    )
  },
  watch: { //使用watch 监听$router的变化
    $route(to, from) {
      //如果to索引大于from索引,判断为前进状态,反之则为后退状态
      if (to.meta.index > from.meta.index) {
        console.log(111)
        console.log(to)
        console.log(from)
      } else {
        //			如果跳转到空白页在跳回来
        if (to.fullPath == '/redirect') {
          console.log(333)
          setTimeout(() => {
            this.$router.replace({ //replace跟 router.push 很像，唯一的不同就是，它不会向 history 添加新记录，
              path: from.fullPath
            })
          }, 200)
        }
      }
    }
  },
  methouds: {}
}
</script>

<style>
@import "../static/css/animate.css";

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 全局样式 */
/* 图片浏览样式开始 */
.lz-el-image {
  width: 100px;
  height: 100px;
  border-radius: 5px;
  background: #F5F7FA;
  line-height: 100px;
  font-size: 30px;
  text-align: center;
  margin-right: 5px;
}

/* 图片浏览样式结束 */
/* 分页公用样式 */
.lz-el-pagination {
  margin: 20px 0;
  float: right;
  position: relative;
}


</style>



// WEBPACK FOOTER //
// src/App.vue